import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Upload02 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="upload-02">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3219 2.26594C11.7052 1.91135 12.2968 1.91135 12.68 2.26594L17.6127 6.82912C18.0181 7.20417 18.0427 7.83685 17.6676 8.24226C17.2926 8.64767 16.6599 8.67229 16.2545 8.29724L13.001 5.28739L13.001 14.9425C13.001 15.4948 12.5532 15.9425 12.001 15.9425C11.4487 15.9425 11.001 15.4948 11.001 14.9425L11.001 5.28739L7.74744 8.29724C7.34203 8.67229 6.70934 8.64767 6.33429 8.24226C5.95924 7.83685 5.98386 7.20416 6.38927 6.82912L11.3219 2.26594ZM4 17.9663C4.55228 17.9663 5 18.4141 5 18.9663V19.8791C5.16039 19.9573 5.34012 20 5.52595 20H18.4741C18.6599 20 18.8396 19.9573 19 19.8791V18.9663C19 18.4141 19.4477 17.9663 20 17.9663C20.5523 17.9663 21 18.4141 21 18.9663V20.3827C21 20.6521 20.8914 20.91 20.6987 21.0982C20.1047 21.6782 19.3041 22 18.4741 22H5.52595C4.69593 22 3.89528 21.6782 3.30132 21.0982C3.10863 20.91 3 20.6521 3 20.3827V18.9663C3 18.4141 3.44772 17.9663 4 17.9663Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
